import React from "react";
import plus from "icons/plus-grey.svg";
import { ReactComponent as MenuIcon } from "icons/threeDots.svg";
import { buttonVariants } from "@visiblethread/react-components/dist/components/Button";
import {
  DELETE_WORKSPACE_BUTTON,
  RENAME_WORKSPACES_BUTTON,
  RESERVED_LICENSES_BUTTON,
  CONFIGURE_BANNER_WORKSPACE_BUTTON,
} from "constants/systemAdmin";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { showModal } from "slices/app/actions/modals";
import { modalTypes } from "constants/types";
import { renameWorkspace } from "slices/systemAdmin/actions/systemAdmin";
import ButtonsDropdownOption from "@visiblethread/react-components/dist/components/Dropdown/ButtonsDropdownOption";
import ButtonsDropdown from "@visiblethread/react-components/dist/components/Dropdown/ButtonsDropdown";
import { htmlDecode } from "utils";

const WorkspacesItem = ({
  workspaceId,
  workspaceName,
  licensedUsers,
  nonLicensedUsers,
  reservedLicenses,
  bannerProperties,
}) => {
  const dispatch = useDispatch();
  const handleDeleteWorkspace = () => {
    dispatch(
      showModal(modalTypes.DELETE_WORKSPACE, {
        workspaceName,
        workspaceId,
      })
    );
  };

  const handleRenameWorkspace = (newWorkspaceName) => {
    dispatch(renameWorkspace(newWorkspaceName, workspaceId));
  };

  const handleReserveLicenses = () =>
    dispatch(
      showModal(modalTypes.WORKSPACE_RESERVED_LICENSES, {
        workspaceName,
        workspaceId,
        licensedUsers,
        reservedLicenses,
      })
    );

  const handleRename = () =>
    dispatch(
      showModal(modalTypes.TEXT_FIELD_MODAL, {
        inputText: workspaceName,
        title: "Rename Workspace",
        placeholderText: "Please enter name",
        buttonText: "Rename",
        errorMessage:
          "New workspace name must only contain alphanumeric characters and following special characters: ()+-.",
        onOk: handleRenameWorkspace,
      })
    );

  const menuOptions = [
    {
      content: "Reserve Licenses",
      onClick: handleReserveLicenses,
      dataTest: RESERVED_LICENSES_BUTTON,
    },
    {
      content: "Rename",
      onClick: handleRename,
      dataTest: RENAME_WORKSPACES_BUTTON,
    },
    {
      content: "Delete Workspace",
      onClick: handleDeleteWorkspace,
      dataTest: DELETE_WORKSPACE_BUTTON,
    },
    {
      content: "Set Banner",
      onClick: () =>
        dispatch(showModal(modalTypes.WORKSPACE_BANNER, { workspaceId })),
      dataTest: CONFIGURE_BANNER_WORKSPACE_BUTTON,
    },
  ];

  const threeDots = () => (
    <ButtonsDropdown
      hideArrowIcon
      button={
        <span>
          <MenuIcon />
        </span>
      }
      options={menuOptions.map(({ content, onClick, dataTest }) => (
        <ButtonsDropdownOption
          content={content}
          onClick={onClick}
          title=""
          data-test={dataTest}
        />
      ))}
      buttonVariant={buttonVariants.secondary}
      offsetTop={39}
      offsetRight={-73}
    />
  );

  return (
    <div
      className="system_admin__container__item"
      data-testid="workspaces-item"
    >
      <div className="system_admin__container__item__name">
        <img src={plus} alt="plus" />
        <span>{workspaceName}</span>
      </div>
      <span className="system_admin__container__item__licensed">
        {licensedUsers}
      </span>
      <span className="system_admin__container__item__non_licensed">
        {nonLicensedUsers}
      </span>
      <span className="system_admin__container__item__reserved_licenses">
        {reservedLicenses}
      </span>
      <span className="system_admin__container__item__banner">
        {bannerProperties.enabled &&
        bannerProperties.message !== "" &&
        bannerProperties.message !== null ? (
          <div
            className="system_admin__container__item__banner__message"
            style={{
              color: bannerProperties.colour,
              backgroundColor: bannerProperties.background,
            }}
          >
            {htmlDecode(bannerProperties.message)}
          </div>
        ) : null}
      </span>
      <span className="system_admin__container__item__actions">
        {threeDots()}
      </span>
    </div>
  );
};

export default WorkspacesItem;

WorkspacesItem.propTypes = {
  workspaceId: PropTypes.number.isRequired,
  workspaceName: PropTypes.string.isRequired,
  licensedUsers: PropTypes.number.isRequired,
  nonLicensedUsers: PropTypes.number.isRequired,
  reservedLicenses: PropTypes.number.isRequired,
  bannerProperties: PropTypes.shape({
    message: PropTypes.string.isRequired,
    colour: PropTypes.string.isRequired,
    background: PropTypes.string.isRequired,
    enabled: PropTypes.bool,
  }),
};
